import { render, staticRenderFns } from "./NeckItem.vue?vue&type=template&id=f4869856&scoped=true&"
import script from "./NeckItem.vue?vue&type=script&lang=js&"
export * from "./NeckItem.vue?vue&type=script&lang=js&"
import style0 from "./NeckItem.vue?vue&type=style&index=0&id=f4869856&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4869856",
  null
  
)

export default component.exports